<div class="copyright-container">
  <div class="copyright">
    {{ copyright$ | async }}
  </div>
</div>
